import { ISpnGridItem } from "@cayo/core/admin-components/grids/SpnGrid/types";

export const getSpnGroupKey = (o: ISpnGridItem) => {
  if (!o) {
    return null;
  }
  const service = String(o.serviceType || "").trim();
  const uoc = String(o.userOrComputer || "").trim();
  if (!service || !uoc) {
    return null;
  }
  const hostNoPort = uoc.split(":")[0];
  const shortHost = hostNoPort.split(".")[0];
  return service.toLowerCase() + "|" + shortHost.toLowerCase();
};

export const groupParsedSpns = (items: ISpnGridItem[]) => {
  if (!Array.isArray(items)) {
    throw new Error("items must be an array");
  }
  const groupDisplay: { [key: string]: ISpnGridItem } = {};
  for (const o of items) {
    const key = getSpnGroupKey(o);
    if (!key) {
      continue;
    }
    const uoc = String(o.userOrComputer || "").trim();
    if (!groupDisplay[key]) {
      groupDisplay[key] = o;
    } else {
      if (uoc > String(groupDisplay[key].userOrComputer || "")) {
        groupDisplay[key] = o;
      }
    }
  }
  return Object.values(groupDisplay);
};

// key = collapsed item's originalSPN, value = expanded list for that collapsed group
export const groupExpandedAndCollapsedByKey = (
  expandedItems: ISpnGridItem[],
  collapsedItems: ISpnGridItem[]
) => {
  if (!Array.isArray(expandedItems)) {
    throw new Error("expandedItems must be an array");
  }
  if (!Array.isArray(collapsedItems)) {
    throw new Error("collapsedItems must be an array");
  }
  const result: { [key: string]: ISpnGridItem[] } = {};
  const groupKeyToCollapsed: { [key: string]: string } = {};
  // index collapsed
  for (const c of collapsedItems) {
    const gk = getSpnGroupKey(c);
    if (!gk) {
      continue;
    }
    const collapsedSpn = c.originalSPN;
    if (!collapsedSpn) {
      continue;
    }
    groupKeyToCollapsed[gk] = collapsedSpn;
    if (!result[collapsedSpn]) {
      result[collapsedSpn] = [];
    }
  }
  // assign expanded to collapsed by shared groupKey
  for (const e of expandedItems) {
    const gk = getSpnGroupKey(e);
    if (!gk) {
      continue;
    }
    const collapsedSpn = groupKeyToCollapsed[gk];
    if (!collapsedSpn) {
      continue;
    }
    result[collapsedSpn].push(e);
  }
  return result;
};
